module.exports = __webpack_public_path__ + "static/media/list.c3360e55.svg";